import { render, staticRenderFns } from "./LabelTooltip.vue?vue&type=template&id=6f6ce6d8&lang=pug&"
import script from "./LabelTooltip.vue?vue&type=script&lang=js&"
export * from "./LabelTooltip.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports